import type { ApiError } from '../../../../common/api/graphql/apolloClient';
import { requestMessageThreadFileUrl } from '../../../../common/api/graphql/requestMessageThreadFileUrlGql';
import type {
  DownloadUrl,
  RequestMessageThreadFileUrlResponse
} from '../../../../common/api/graphql/requestMessageThreadFileUrlGql';
import type { UploadedFileUrlCode } from '../../../../common/api/graphql/uploadFileGql';
import {
  requestMessageThreadFileUrlFailure,
  requestMessageThreadFileUrlStart,
  requestMessageThreadFileUrlSuccess
} from '../actions';
import type { AppThunkAction } from '../thunkType';
import handleApiErrorIfNeeded from './handleApiErrorIfNeeded';

const requestMessageThreadFileUrlSuccessThunk =
  (
    response: RequestMessageThreadFileUrlResponse
  ): AppThunkAction<Promise<string>> =>
  dispatch => {
    const { downloadUrl } = response.data!.requestMessageThreadFileUrl;
    dispatch(requestMessageThreadFileUrlSuccess());
    return Promise.resolve(downloadUrl);
  };

export const requestMessageThreadFileUrlFailureThunk =
  (error: ApiError): AppThunkAction<Promise<void>> =>
  dispatch => {
    dispatch(requestMessageThreadFileUrlFailure());
    return dispatch(handleApiErrorIfNeeded(error));
  };

export const requestMessageThreadFileUrlThunk =
  (urlCode: UploadedFileUrlCode): AppThunkAction<Promise<DownloadUrl | void>> =>
  dispatch => {
    dispatch(requestMessageThreadFileUrlStart());

    return requestMessageThreadFileUrl(urlCode)
      .then((response: RequestMessageThreadFileUrlResponse) =>
        dispatch(requestMessageThreadFileUrlSuccessThunk(response))
      )
      .catch(error => dispatch(requestMessageThreadFileUrlFailureThunk(error)));
  };
